<div [@routerTransition]>
  
  <div class="card my-profile-form margin-top-20px" *ngIf="ShowList">
    <div class="card-header wh-header">
      <div class="row">
        <div class="col-md-3">
          Schedular
        </div>
        <div class="col-md-9 text-align-right">
          <!--<button class="btn actions-btn-prime float-right" (click)="clearData()"><i class="fa fa-plus nav-link-hand"></i>  Add</button>-->
          <a (click)="clearData()" class="nav-link-hand patientreg-link" title="Click here for New Registration">New Registration</a>
          <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>--><!--(click)="gotoprofile()"-->
        </div>
      </div>

    </div>
    <div class="card-body">
      <div class="table-component">
        <div class="table-responsive overflow-x">


          <table class="table table-striped margin-left-zero"
                 cols="auto,2*,*,*,*,*,*,*">

            <thead class="">
              <tr>

                <th class="">
                    PID
                </th>
                <!--<th class="text-align-center">Day</th>-->

                <th class="text-align-center">
                  Old Reg No
                </th>
                <th class="">
                  Name
                </th>
                <!--<th class="text-align-center">Start Time</th>-->
                <th class="">
                  Reg Date
                </th>

                <th class="">
                  Prime Relation
                </th>

                <th class="">
                  Contact
                </th>
                <th class="">
                  Sex
                </th>
                <th class="">Age</th>

                <th>Marital </th>
                <th>Category</th>
                <th></th>



              </tr>
            </thead>

            <tbody class="table-body">
              <tr>

                <td class="td-padding "> <a (click)="gotoviewprofile()" class="nav-link-hand">Job 1</a>  </td>
                <!--<td class="td-padding text-align-center">Mon</td>-->
                <td class="td-padding text-align-center">

                  10-11-2018
                </td>
                <td class=" td-padding ">day</td>
                <!--<td class="td-padding text-align-center"></td>-->
                <td class=" ">Rn</td>
                <td class="  ">List</td>

                <td class="">mandatory</td>
                <td class=" ">Shift</td>
                <td class=" td-padding ">red</td>

                <td>1</td>
                <td>2</td>

                
                <td>
                  <div class="row">
                    <a (click)="edit_(l)" class="nav-link-hand education-navlink" title="Edit">
                      <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                    </a>
                    <a (click)="del_(l.EducationCode)" class="nav-link-hand education-navlink" title="Remove">
                      <span class="badge">
                        <i class="far fa-trash-alt"></i>
                      </span>
                    </a>
                   
                  </div>
                </td>



              </tr>

            </tbody>

          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf='isNew && !ShowList'>
  
  <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

    <div class="comon-box margin-left-zero p-0 margin-top-20px">
      <div class="row">
        <div class="col-md-3">
          <h4 class="heading-pinkbg mt-0">New Patient</h4>
        </div>
        <div class="col-md-9 margin-top-10">

          <button type="submit" *ngIf='!isRequesting' (click)="gotoprofile()" class="btn actions-btn-prime nav-link-hand float-right margin-right-10px">Save</button>
          <button (click)="CancelNewOperation()" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right">Cancel</button>
        </div>
      </div>
      <div class="row my-profile-form margin-top-form">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-3 text-align-right">
              <label for="firstName" class="label-size"><span>*</span> Name </label>
            </div>
            <div class="col-md-2">

              <input type="text" class="form-control form-control-patient" placeholder="First Name"> <!--id="CurrentActorPersonalDetailInfoRequest.FirstName"
                     [(ngModel)]="CurrentActorPersonalDetailInfoRequest.FirstName"
                     name="CurrentActorPersonalDetailInfoRequest.FirstName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                     placeholder="First Name" maxlength="20" minlength="1" #FirstName="ngModel" required-->
              <!--<small class="form-text text-danger"
                     *ngIf="(!FirstName.valid && (FirstName.dirty || FirstName.touched) && FirstName.errors.required )">(Field cannot be left blank)</small>
              <small class="form-text text-danger"
                     *ngIf="(!FirstName.valid && FirstName.errors.pattern)">(special characters are not allowed)</small>-->

            </div>
            <div class="col-md-2">

              <input type="text" class="form-control form-control-patient" placeholder="Middle Name"> <!--id="CurrentActorPersonalDetailInfoRequest.MiddleName"
                     [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MiddleName"
                     name="CurrentActorPersonalDetailInfoRequest.MiddleName"
                     placeholder="Middle Name" maxlength="20" pattern="^[\sa-zA-Z0-9,._\-?]*$" #MiddleName="ngModel" required-->
              <!--<small class="form-text text-danger"
                     *ngIf="(!MiddleName.valid && MiddleName.errors.pattern)">(special characters are not allowed)</small>-->

            </div>
            <div class="col-md-2">


              <input type="text" class="form-control form-control-patient" placeholder="Last Name" > <!--id="CurrentActorPersonalDetailInfoRequest.LastName"
                     [(ngModel)]="CurrentActorPersonalDetailInfoRequest.LastName"
                     name="CurrentActorPersonalDetailInfoRequest.LastName"
                     placeholder="Last Name" required maxlength="20" minlength="1" #LastName="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"-->
              <!--<small class="form-text text-danger"
                     *ngIf="(!LastName.valid && (LastName.dirty || LastName.touched) && LastName.errors.required)">(Field cannot be left blank)</small>
              <small class="form-text text-danger"
                     *ngIf="(!LastName.valid && LastName.errors.pattern)">(special characters are not allowed)</small>-->

            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-3 text-align-right">
              <label for="birthDate" class="label-size"><span>*</span> Date of Birth  </label>
            </div>
            <div class="col-md-2">
              <div class="date-form">
                <input class="form-control form-control-patient" placeholder="Date Of Birth" [minDate]="minDate" [maxDate]="maxDate"
                       name="dp" [(ngModel)]="DOB" ngbDatepicker #d="ngbDatepicker" required #DateOfBirth="ngModel">
                <small class="form-text text-danger"
                       *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                <a (click)="d.toggle()" class="nav-link-hand">
                  <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                </a>

              </div>
            </div>


          </div>
        </div>

      </div>
      <div class="row my-profile-form">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-3 text-align-right">
              <label for="diaplayName" class="label-size"><span>*</span> Sex</label>
            </div>

            <div class="col-md-2">
              <CodeTypeValue CodeType="Sex">
                <!--id="CurrentActorPersonalDetailInfoRequest.MaritalStatus"
            [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MaritalStatus" SelectedValue="{{CurrentActorPersonalDetailInfoRequest.MaritalStatus}}"
            name="CurrentActorPersonalDetailInfoRequest.MaritalStatus"-->
              </CodeTypeValue>

            </div>
          </div>


        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-3 text-align-right">
              <label for="diaplayName" class="label-size"><span>*</span> Contact Number </label>
            </div>
            <div class="col-md-2">
              <input type="tel" class="form-control form-control-patient" placeholder="Contact Number" /> <!--id="CurrentActorPersonalDetailInfoRequest.Telephone1"
                     [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Telephone1"
                     mask="(000) 000-0000"
                     name="CurrentActorPersonalDetailInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel"
                     placeholder="Mobile Phone"--> 
              <!--<small class="form-text text-danger"
                     *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->
            </div>
          </div>


        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">

            <div class="col-md-3 text-align-right">
              <label for="email address" class="label-size"><span>*</span> Email Address  </label>
            </div>
            <div class="col-md-3">
              <input type="email" class="form-control form-control-patient" id="CurrentActorPersonalDetailInfoRequest.Email" placeholder="Email" >
                     <!--[(ngModel)]="CurrentActorPersonalDetailInfoRequest.Email"
                     name="CurrentActorPersonalDetailInfoRequest.Email"
                     placeholder="Email" required pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                     #Email="ngModel" maxlength="30" minlength="4"-->
              <!--<small class="form-text text-danger"
                     *ngIf="(!Email.valid && (Email.dirty || Email.touched)  && Email.errors.required)">(Provide Valid Email)</small>-->
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-3 text-align-right">
              <label for="diaplayName" class="label-size">Address</label>
            </div>
            <div class="col-md-3">
              <input type="text" class="form-control form-control-patient" id="CurrentActorPersonalDetailInfoRequest.AddressLine1"  placeholder="Address"/>
                     <!--[(ngModel)]="CurrentActorPersonalDetailInfoRequest.AddressLine1"
                     name="CurrentActorPersonalDetailInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                     placeholder="Address Line1" maxlength="100"--> 
              <!--<small class="form-text text-danger"
                     *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
            </div>
          </div>


        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-3 text-align-right">
              <label for="diaplayName" class="label-size"><span>*</span> City </label>
            </div>
            <div class="col-md-2">
              <input type="text" class="form-control form-control-patient" id="CurrentActorPersonalDetailInfoRequest.City" placeholder="City" />
                     <!--[(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                     name="CurrentActorPersonalDetailInfoRequest.City"
                     placeholder="City" maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel"-->
              <!--<small class="form-text text-danger"
                     *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
            </div>
          </div>


        </div>
      </div>

      <div class="row my-profile-form">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-3 text-align-right">
              <label for="diaplayName" class="label-size"><span>*</span> State </label>
            </div>
            <div class="col-md-2">
              <CodeTypeValue CodeType="STATE" ></CodeTypeValue> <!--id="CurrentActorPersonalDetailInfoRequest.State"
                             [(ngModel)]="CurrentActorPersonalDetailInfoRequest.State" SelectedValue="{{CurrentActorPersonalDetailInfoRequest.State}}"
                             name="CurrentActorPersonalDetailInfoRequest.State"-->
            </div>
          </div>


        </div>
      </div>
      <!--<div class="row margin-bottom-10px">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-3 text-align-right offset-md-1">
              <label for="diaplayName"><span>*</span> Physician</label>
            </div>

            <div class="col-md-3">
              <CodeTypeValue CodeType="Sex">

              </CodeTypeValue>

            </div>
          </div>


        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-3 offset-md-1 text-align-right">
              <label for="diaplayName"> Description</label>
            </div>

            <div class="col-md-4">
              <textarea class="form-control2" rows="2" placeholder="Description"></textarea>

            </div>
          </div>


        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-3 offset-md-1 text-align-right">
              <label for="diaplayName"> Recommendations</label>
            </div>

            <div class="col-md-4">
              <textarea class="form-control2" rows="2" placeholder="Recommendations"></textarea>

            </div>
          </div>


        </div>
      </div>-->
      <div class="row pl-3 pr-3 margin-left-zero margin-left-zero">


        <!--<div class="form-group col-md-6 col-xs-12">
      <label for="eventInput1"><span>*</span> Physician</label>
      <CustomDataByRequestType RequestedType="CredentialTypeByGroup" CustomType="ActorMedicalFitness" id="CurrentActorMedicalFitnessRequest.CredentialTypeCode"
                               [(ngModel)]="CurrentActorMedicalFitnessRequest.CredentialTypeCode" name="CurrentActorMedicalFitnessRequest.CredentialTypeCode" required
                               (keyChange)="onCredentialTypeByGroup($event)" #CredentialTypeCode="ngModel">
      </CustomDataByRequestType>
      <small class="form-text text-danger"
             *ngIf="(!CredentialTypeCode.valid && (CredentialTypeCode.dirty || CredentialTypeCode.touched) && CredentialTypeCode.errors.required )">(Field cannot be left blank)</small>


    </div>-->
        <!--<div class="form-group col-md-6 col-xs-12">
      <label for="eventInput2">Certificate Number</label>
      <input type="text" class="form-control" id="CurrentActorMedicalFitnessRequest.CredentialNumber" [(ngModel)]="CurrentActorMedicalFitnessRequest.CredentialNumber" name="CurrentActorMedicalFitnessRequest.CredentialNumber" placeholder="CredentialNumber">
    </div>-->
        <!--<div class="form-group col-md-6 col-xs-12">
      <label for="eventInput4">Description</label>





    </div>-->
        <!--<div class="form-group col-md-6 col-xs-12">
      <label for="eventInput5">Recommendations</label>

    </div>-->


        <br /><br /><br />  <br /><br /><br />  <br />

      </div>
    </div>
    <!--<div class="row">
      <div class="card-footer text-right col-12">


      </div>
    </div>-->







  </form>
</div>
